import { defineMessages } from '@atlassian/jira-intl';

const messages: {
	securityLevelFieldPlaceHolder: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	securityLevelFieldPlaceHolder: {
		id: 'issue-create.common.fields.security-level-field.security-level-field-place-holder',
		defaultMessage: 'Select Security Level',
		description: 'PlaceHolder text for Security level field in issue create form',
	},
});
export default messages;
